import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { IStore } from 'src/interfaces/store';
import { IMake } from 'src/interfaces/make';
import { uniq } from 'lodash';

interface MakeExtractor {
    extract(store: IStore): string[];
}

class SingleMakeExtractor implements MakeExtractor {
    extract(store: IStore): string[] {
        const makeId = getDocumentId(store?.make);
        if (!makeId) return [];
        return [makeId];
    }
}

class StoreMakesExtractor implements MakeExtractor {
    extract(store: IStore): string[] {
        if (!store?.makes) return [];
        return store?.makes?.map((make) => getDocumentId(make) || '') || [];
    }
}

const makeExtractors: MakeExtractor[] = [
    new StoreMakesExtractor(),
    new SingleMakeExtractor(),
];

/**
 * Extracts the makes ids from the stores
 * @param stores - The stores to extract the makes ids from
 * @returns The makes ids without duplicates
 */
export const extractMakesIdsByStores = (stores: IStore[]) => {
    if (!stores || stores.length === 0) return [];

    const allIds = stores.reduce<string[]>((acc, store) => {
        if (!store.make) return acc;

        const extractedIds = makeExtractors.reduce<string[]>(
            (ids, extractor) => {
                return [...ids, ...extractor.extract(store)];
            },
            []
        );

        return [...acc, ...extractedIds];
    }, []);

    return uniq(allIds);
};
